import { render, staticRenderFns } from "./DiffTable.vue?vue&type=template&id=3c318826&scoped=true"
import script from "./DiffTable.vue?vue&type=script&lang=js"
export * from "./DiffTable.vue?vue&type=script&lang=js"
import style0 from "./DiffTable.vue?vue&type=style&index=0&id=3c318826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c318826",
  null
  
)

export default component.exports